var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    d: "M10 11.191a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    d: "M3.017 7.075C4.658-.14 15.35-.133 16.983 7.084c.959 4.233-1.675 7.816-3.983 10.033a4.33 4.33 0 0 1-6.008 0c-2.3-2.217-4.934-5.808-3.975-10.042Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6304cd85b772940fcab68936671d85c5.svg";
export { ForwardRef as ReactComponent };